<pap-sign-in
  (loginData)="loginData($event)"
  logoSrc="assets/images/logo.svg"
  [apiError] = "apiErrorMsg"
  >
</pap-sign-in>
